/* =========================================================
   Inline header search on phones (theme v1.14)
   At <=749px the header search icon opens a search row inside the
   header instead of navigating to /search. Wider screens are not
   touched: the icon stays a normal link to /search.
   Suggestions are provided by assets/cc-search-suggest.js.
   ========================================================= */
(function () {
  'use strict';

  var btn = document.querySelector('.header-search-btn');
  var row = document.querySelector('[data-cc-hsearch]');
  if (!btn || !row || !window.matchMedia) return;

  var mq = window.matchMedia('(max-width: 749px)');
  var input = row.querySelector('[data-cc-search-input]');
  var list = row.querySelector('[data-cc-suggest]');
  var closeBtn = row.querySelector('[data-cc-hsearch-close]');

  function isOpen() { return !row.hidden; }

  function hideSuggestions() {
    if (!list) return;
    list.hidden = true;
    list.innerHTML = '';
    input.setAttribute('aria-expanded', 'false');
    input.removeAttribute('aria-activedescendant');
  }

  function open() {
    row.hidden = false;
    btn.setAttribute('aria-expanded', 'true');
    input.focus();   // same tap, so phones show the keyboard
  }

  function close(returnFocus) {
    if (!isOpen()) return;
    hideSuggestions();
    row.hidden = true;
    btn.setAttribute('aria-expanded', 'false');
    if (returnFocus) btn.focus();
  }

  // ARIA only while the icon acts as a toggle (phones).
  function syncAria() {
    if (mq.matches) {
      btn.setAttribute('aria-controls', row.id);
      btn.setAttribute('aria-expanded', isOpen() ? 'true' : 'false');
    } else {
      close(false);
      btn.removeAttribute('aria-controls');
      btn.removeAttribute('aria-expanded');
    }
  }

  btn.addEventListener('click', function (e) {
    if (!mq.matches) return;            // desktop / tablet: normal link to /search
    e.preventDefault();
    if (isOpen()) close(false); else open();
  });

  if (closeBtn) closeBtn.addEventListener('click', function () { close(true); });

  // Esc closes the row (the first Esc closes an open suggestion list instead).
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !isOpen() || e.defaultPrevented) return;
    close(true);
  });

  // Tap outside the header row / icon closes it (this includes the menu button).
  document.addEventListener('click', function (e) {
    if (!isOpen()) return;
    if (row.contains(e.target) || btn.contains(e.target)) return;
    close(false);
  });

  if (mq.addEventListener) mq.addEventListener('change', syncAria);
  else if (mq.addListener) mq.addListener(syncAria);
  syncAria();
})();
